export default __webpack_public_path__ + "static/media/burger-menu.ed81956a.svg";